module.exports = __webpack_public_path__ + "img/header20.ef796f59.jpg";